// Detect whether the visitor should see Australian (TGA/AHPRA) compliance mode,
// which hides prescription-medicine names/prices and testimonials.
// A manual region override (set by the footer selector) always wins over
// auto-detection so a user can force the correct rules.
const OVERRIDE_KEY = "region_override"; // "au" | "intl" | "" (auto)

export function getRegionOverride() {
  try {
    return localStorage.getItem(OVERRIDE_KEY) || "";
  } catch (e) {
    return "";
  }
}

export function setRegionOverride(value) {
  try {
    if (value === "au" || value === "intl") localStorage.setItem(OVERRIDE_KEY, value);
    else localStorage.removeItem(OVERRIDE_KEY);
  } catch (e) {
    /* ignore */
  }
}

function autoDetectAu(userCountry) {
  try {
    if (userCountry && /austral/i.test(userCountry)) return true;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (/^Australia\//.test(tz)) return true;
    const langs = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
    if (langs.some((l) => /-AU$/i.test(l))) return true;
  } catch (e) {
    /* ignore */
  }
  return false;
}

export function isAuVisitor(userCountry) {
  const override = getRegionOverride();
  if (override === "au") return true;
  if (override === "intl") return false;
  return autoDetectAu(userCountry);
}

// Query params to send to clinic endpoints when in AU compliance mode.
export function auParams(userCountry) {
  return isAuVisitor(userCountry) ? { au: true } : {};
}
